import { render, staticRenderFns } from "./UpsertEditorialProjectModal.vue?vue&type=template&id=562ac384&"
import script from "./UpsertEditorialProjectModal.vue?vue&type=script&lang=ts&"
export * from "./UpsertEditorialProjectModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports